import { TBrand } from '../../../Molecules/brand-slider';
import { rewardList } from '../../../S/Rewards/rewards_category';

export const splitArrayInHalf = <T>(array: T[]): [T[], T[]] => {
  if (!Array.isArray(array) || array.length === 0) {
    return [[], []];
  }

  const half = Math.floor(array.length / 2);
  const firstHalf = array.slice(0, half);
  const secondHalf = array.slice(half);
  return [firstHalf, secondHalf];
};

export const getSliderDataForRewards = (rewards: rewardList[]): TBrand =>
  rewards.map((reward) => ({
    id: `${reward.id}`,
    logo: `https://assets1.cleartax-cdn.com/${reward.logoUrl}`,
  }));
